import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SetupStoreComponent } from 'src/app/_layouts/components/modal/setup-store/setup-store.component';
import { StatusService } from 'src/app/services/status.service';
import { AuthManager } from 'src/app/core/auth/auth.manager';
import { ToastrService } from 'ngx-toastr';
import { FacilityManager } from 'src/app/managers/facility.manager';

import { MatButton } from '@angular/material/button';
import { FacilitySelectionComponent } from '../facility-selection/facility-selection.component';
import { SidebarNavigationComponent } from '../sidebar-navigation/sidebar-navigation.component';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [
    MatButton,
    FacilitySelectionComponent,
    SidebarNavigationComponent,
    RouterOutlet,
    MatProgressSpinner,
    MatProgressBar,
  ],
})
export class MainLayoutComponent implements OnInit {
  public isFacilitySelected: boolean;
  public username = '';
  public loginDisplay = false;
  public authManager: AuthManager;

  constructor(
    private _facilityManager: FacilityManager,
    private auth: AuthManager,
    public statusService: StatusService,
    public dialog: MatDialog,
    private toastr: ToastrService,
  ) {
    this.isFacilitySelected = this._facilityManager.isFacilitySelected();
    this.authManager = this.auth;
  }

  public ngOnInit(): void {
    this.username = this.auth.getUsername();
    this.loginDisplay = this.auth.loginDisplay;
    this._facilityManager.facilityIdUpdates$.subscribe({
      next: (fId) => {
        this.isFacilitySelected = this._facilityManager.isFacilitySelected();
      },
    });

    this.authManager.isLoggedIn$.subscribe((isAuthed) => {
      this.username = this.auth.getUsername();
      this.loginDisplay = this.auth.loginDisplay;
    });
  }

  public openSetupNewStoreDialog(): void {
    const dialogRef = this.dialog.open(SetupStoreComponent, {
      width: '600px',
      maxHeight: '700px',
      maxWidth: '700px',
    });
  }

  public loginRedirect(): void {
    this.auth.loginRedirect();
  }
}
